module.exports = __webpack_public_path__ + "static/media/muted.522b4049.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/TrackControl/muted.svg
// module id = 255
// module chunks = 0